<app-modal-generico [modelo]="modalGenerico">
  <div class="table-responsive">
    <div class="card mb-3">
      <div class="card-body">
        <form [formGroup]="filtro" (submit)="consultaTabla()">
          <div class="row">
            <div class="col-2 form-group">
              <label class="small text-secondary mb-0" for="">Nombre establecimiento</label>
              <input type="text" class="form-control form-control-sm" formControlName="nombre_establecimiento">
            </div>
            <div class="col-2 form-group">
              <label class="small text-secondary mb-0">Departamento</label>
              <select id="departamento_id" formControlName="departamento_id" class="form-control" (change)="onMunicipio()">
                <option class="" [ngValue]="null" selected="true">
                  Seleccione
                </option>
                <ng-container *ngFor="let item of departamentos">
                  <option [ngValue]="item.departamento_id">{{item.descripcion}}</option>
                </ng-container>
              </select>
            </div>
            <div class="col-2 form-group">
              <label class="small text-secondary mb-0">Municipio</label>
              <select id="municipio_id" formControlName="municipio_id" class="form-control">
                <option class="" [ngValue]="null" selected="true">
                  Seleccione
                </option>
                <ng-container *ngFor="let item of municipios">
                  <option [ngValue]="item.municipio_id">{{item.descripcion}}</option>
                </ng-container>
              </select>
            </div>
            <div class="col-2 form-group">
              <label class="small text-secondary mb-0" for="">Cámara de Comercio</label>
              <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                <option class="" [ngValue]="null" selected="true">
                  Seleccione
                </option>
                <option class="" *ngFor="let option of camarasLista; let i = index" value="{{option?.codigo_camara}}"
                  [selected]="false">
                  {{option?.desc_camara}}
                </option>
              </select>
            </div>
            <div class="col-2 form-group">
              <label class="small text-secondary mb-0" for="">Número de matrícula</label>
              <input type="text" class="form-control form-control-sm" formControlName="matricula">
            </div>
            <div class="col-2 form-row">
              <button type="reset" class="btn btn-outline-primary border-0 m-auto" (click)="limpiar()">Limpiar</button>
              <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <app-tablas [page] = "paginaActual" [headers]="headers" [sizeData]="datoPaginadoModel.paging.totalItems" (paginado)="onPaginado($event)">
      <tr class="small" *ngFor="let item of datoPaginadoModel.items; let i = index" (click)="selectRow(item)" [ngClass]="{'modal-establecimiento-tabla-select': i === datoPaginadoModel.items.indexOf(selectData)}">
        <td>
          <!-- <input type="checkbox" class="ml-1  form-check-input" [checked]="i === establecimientos.indexOf(selectData)"
            disabled=true> -->
          <img src="../../../../../../../../assets/icons/checked_2.png" alt="" height="18" *ngIf="i !== datoPaginadoModel.items.indexOf(selectData)">
          <img src="../../../../../../../../assets/icons/checked.png" alt="" height="18" *ngIf="i === datoPaginadoModel.items.indexOf(selectData)">
        </td>
        <td>{{item.razon_social}}</td>
        <td>{{item.direccion_comercial}}</td>
        <td>{{item.desc_dpto}}</td>
        <td>{{item.desc_municipio}}</td>
        <td>{{item.desc_camara}}</td>
        <td>{{item.matricula}}</td>
      </tr>
    </app-tablas>
  </div>
  <footer class="text-right p-1">
    <button class="btn btn-outline-primary modal-establecimiento-btn-inicio-outline mr-5 border-0" (click)="dismiss()">Cancelar</button>
    <button class="btn btn-primary modal-establecimiento-btn-inicio" (click)="confirm()" [style.opacity]="!selectData ? 0.4:1">Aceptar</button>
  </footer>
</app-modal-generico>